<div class="user-role-container">
  <h1 class="page-title">User Role List</h1>
  
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <div class="table-header">
    <div class="role-count">

      <span class="count-text">Total User Role: {{ totalRoles }}</span>
    </div>
    <div class="header-controls">
       <div class="search-container">
          <i class="pi pi-search search-icon"></i>
          <input 
            type="text" 
            pInputText 
            placeholder="Search role name"
            class="search-input"
            [(ngModel)]="searchTerm"
            (input)="searchRoles()"
          />
        </div>
      <!-- <button class="create-btn">+ Create</button> -->
    </div>
  </div>

  <div class="table-container">
    <table class="role-table">
      <thead>
        <tr>
          <th class="role-name-header">Role Name</th>
          <th class="menu-mapping-header">Menu Mapping</th>
          <th class="update-date-header">Update Date</th>
          <th class="action-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let role of roles" class="table-row">
          <td class="role-name-cell">{{ role.roleName || 'N/A' }}</td>
          <td class="menu-mapping-cell">{{ getMenuMapping(role) }}</td>
          <td class="update-date-cell">{{ formatDate(role.updatedAt) }}</td>
          <td class="action-cell">
            <p-button id="step4-tour" type="button" icon="pi pi-eye"
              styleClass="p-button-rounded p-button-text p-button-info"(click)="viewRole(role.roleId)">
           </p-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- <div class="pagination-container">
    <button class="pagination-btn prev-btn">← Previous</button>
    <div class="pagination-numbers">
      <span class="page-number active">1</span>
      <span class="page-dots">...</span>
      <span class="page-number">3</span>
    </div>
    <button class="pagination-btn next-btn">Next →</button>
  </div> -->
</div>